const letters = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "yo",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "kh",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  ы: "y",
  э: "e",
  ю: "yu",
  я: "ya",
  ө: "ö",
  ң: "ng",
  ү: "ü",
  һ: "h",
};

export function CyrillicToLatin(str) {
  return str
    .split("")
    .map((char) => {
      const lowerChar = char.toLowerCase();
      let letter = letters[lowerChar] || char;
      if (char !== lowerChar) {
        letter = letter.toUpperCase();
      }

      return letter;
    })
    .join("");
}
